// extracted by mini-css-extract-plugin
export default {"autoComplete":"k4C9D2b9","label":"ZapEz8o9","input":"Yj2ve0xp"};